import axios from "axios";
import { getUserFromStorage } from "services/storage-utils";

// const frontendURL = "http://react-based-dev.us-west-2.elasticbeanstalk.com"; // Replace with your frontend URL
const frontendURL = "http://react-live-test.us-west-2.elasticbeanstalk.com/"; // Replace with your frontend URL

const axiosInstance = axios.create({
  baseURL: "https://api.fortinves.tech/",
  // baseURL: "http://127.0.0.1:8000/",
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const userData = getUserFromStorage();
    const token = userData ? userData.token : null;
    // const token = "";

    if (token) {
      config.headers.Authorization = `Token ${token}`;
    }

    // Set the Referer header based on the frontend URL
    // config.headers.Referer = frontendURL;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axiosInstance;
